import React, { useState, useEffect } from "react";
import { setKey } from "../store/actions";
import { connect } from "react-redux";
import { Link, NavLink, Redirect } from "react-router-dom";
import productService from "../services/product";
import { swalError } from '../utils/swal';
import ProductBox from "./ProductBox";
import keys from "../store/keys";

function RecommendedProducts({ session, setKey, ...props }) {

	const [recommendedProducts, setRecommendedProducts] = useState([]);
	const scrollSpeed = 500;

	useEffect(() => {
		reloadRecommendedProducts(props.data.subCategories, props.data._id);
	}, []);

	const reloadRecommendedProducts = (subCategories, productId) => {
		let data = {
			subCategories: subCategories,
			currency: session.selectedRegion ? session.selectedRegion.currency : "EUR"
		};

		setKey(keys.isLoading, true);
		setRecommendedProducts([]);
		productService.getRecommended(session.token, data)
			.then(result => {
				if (result.error) {
					swalError(result.error);
					return;
				}

				let filtered = result.data.filter(k => k._id !== productId);
				setRecommendedProducts(filtered);
				setKey(keys.isLoading, false);
			});
	}

	const renderRecommendedProducts = () => {
		if (!recommendedProducts || recommendedProducts.length === 0)
			return (<div>No data found.</div>);

		return recommendedProducts.map(k => <ProductBox key={k._id} data={k} />)
	}

	const moveLeft = e => {
		e.preventDefault();
		document.getElementById('recommended-products').scrollLeft -= scrollSpeed;
	}

	const moveRight = e => {
		e.preventDefault();
		document.getElementById('recommended-products').scrollLeft += scrollSpeed;
	}

	return (
		<>
			<div className="row mt-20 recommended">
						<div className="col">
							<p className="cart-title">You May Also Like</p>
						</div>
						<div className="col text-end">
							<i className="fa-solid fa-chevron-left mr-30" onClick={moveLeft}></i>
							<i className="fa-solid fa-chevron-right" onClick={moveRight}></i>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div className="recommended-products" id="recommended-products">
								{renderRecommendedProducts()}
							</div>
						</div>
					</div>
		</>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecommendedProducts);
